"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagProps = exports.NTag = void 0;
var Tag_1 = require("./src/Tag");
Object.defineProperty(exports, "NTag", { enumerable: true, get: function () { return __importDefault(Tag_1).default; } });
Object.defineProperty(exports, "tagProps", { enumerable: true, get: function () { return Tag_1.tagProps; } });
